import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";
import { Label, Popup, Icon } from "semantic-ui-react";

import { AT_TYPES } from "../../constants/entity.js";
import { MARKING_STATES } from "../../utils/marking.js";
import { selectCopy } from "../../state/reducers/locale/copySelector.js";

const copyMap = [
  "accepted",
  "created",
  "creating",
  "converged",
  "converging",
  "default",
  "deleted",
  "deleted_invite",
  "deleting",
  "destroyed",
  "destroying",
  "due",
  "errored",
  "erroring",
  "expired",
  "imaging",
  "locked",
  "overdue",
  "paid",
  "pending",
  "pendingObject",
  "pendingSubject",
  "rejected",
  "started",
  "starting",
  "stopped",
  "stopping",
  "tripped",
  "verified",
  "verifying"
];

class ResourceMarker extends PureComponent {
  static propTypes = {
    circular: PropTypes.bool,
    className: PropTypes.string,
    copy: PropTypes.func.isRequired,
    marking: PropTypes.string,
    style: PropTypes.object,
    type: PropTypes.string
  };

  getLabelData = (color, marking, icon) => {
    const { copy } = this.props;

    let text = marking;
    if (copyMap.indexOf(marking) > -1) {
      text = copy(`marking.${marking}`);
    }

    if (!text || text === "") {
      text = copy(`marking.default`);
    }

    return { color, text, icon };
  };

  getLabelByMarking = (marking, type) => {
    switch (marking) {
      // Infrastructure initial states
      case MARKING_STATES.CREATING:
        return this.getLabelData("blue", marking, "");
      case MARKING_STATES.CREATED:
        return this.getLabelData("blue", marking, "check");

      // Infrastructure transition states
      case MARKING_STATES.CONVERGING:
      case MARKING_STATES.VERIFYING:
      case MARKING_STATES.IMAGING:
        return this.getLabelData("yellow", marking, "");

      // Infrastructure ready states
      case MARKING_STATES.CONVERGED:
      case MARKING_STATES.VERIFIED:
      case MARKING_STATES.STARTING:
      case MARKING_STATES.STARTED:
      case MARKING_STATES.STOPPING:
      case MARKING_STATES.STOPPED:
        return this.getLabelData("green", marking, "check");

      case MARKING_STATES.LOCKED:
        return this.getLabelData("grey", marking, "lock");

      // Tear down states
      case MARKING_STATES.DELETING:
      case MARKING_STATES.DESTROYING:
        return this.getLabelData("orange", marking, "minus");
      case MARKING_STATES.DELETED:
        if (type === AT_TYPES.INVITE) {
          return this.getLabelData("red", "deleted_invite", "times");
        }
        return this.getLabelData("orange", marking, "minus");
      case MARKING_STATES.DESTROYED:
        return this.getLabelData("grey", marking, "times");

      // Error states
      case MARKING_STATES.ERRORING:
      case MARKING_STATES.ERRORED:
        return this.getLabelData("red", marking, "exclamation");

      // Invoice states
      case MARKING_STATES.DUE:
        return this.getLabelData("orange", marking);
      case MARKING_STATES.OVERDUE:
        return this.getLabelData("red", marking, "exclamation");
      case MARKING_STATES.PAID:
        return this.getLabelData("green", marking, "check");

      // Invite states
      case MARKING_STATES.PENDING:
        return this.getLabelData("orange", marking);
      case MARKING_STATES.PENDING_OBJECT:
        return this.getLabelData("blue", marking);
      case MARKING_STATES.PENDING_SUBJECT:
        return this.getLabelData("orange", marking);
      case MARKING_STATES.ACCEPTED:
        return this.getLabelData("green", marking, "check");
      case MARKING_STATES.REJECTED:
        return this.getLabelData("red", marking, "exclamation");
      case MARKING_STATES.EXPIRED:
        return this.getLabelData("red", marking, "exclamation");

      default:
        return this.getLabelData("grey", marking, "");
    }
  };

  render() {
    const { marking, circular, className, style, type } = this.props;

    const data = this.getLabelByMarking(marking, type);
    const size = circular ? "large" : "small";

    if (circular) {
      return (
        <Popup
          trigger={
            <Icon
              className={`${data.icon} circle`}
              color={data.color}
              size="large"
            />
          }
          position="top right"
          size="tiny"
          offset={[5, 0]}
          hideOnScroll
          content={data.text}
        />
      );
    }

    const labelClassName = !className
      ? "resource-marker"
      : `${className} resource-marker`;

    return (
      <Label
        tag={!circular}
        color={data.color}
        size={size}
        className={labelClassName}
        style={style}
      >
        <Icon className={`${data.icon} circle`} />
        {`  ${data.text}  `}
      </Label>
    );
  }
}

const mapStateToProps = state => ({
  copy: selectCopy(state)
});

export default connect(mapStateToProps)(ResourceMarker);
